import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import index from '../view/index/index'
// import footer from '../view/footer'

Vue.use(Router)

// const routes = [
//   { path: '/', component: index }
//   // { path: '/contactUs', component: footer }
//   // 添加其他页面组件的路由配置
// ]
//
// const router = new Router({
//   mode: 'history',
//   routes,
//   scrollBehavior (to, from, savedPosition) {
//     // 如果存在 savedPosition，则恢复到保存的位置
//     if (savedPosition) {
//       return savedPosition
//     }
//     // 否则滚动到页面的顶部
//     return { x: 0, y: 0 }
//   }
// })
// export default router

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    // 首页
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('../view/index')
    },
    {
      path: '/index',
      name: 'index',
      // component: () => import('../view/home/Home')
      component: () => import('../view/index/index')
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      // component: () => import('../view/aboutUs/AboutUs')
      component: () => import('../view/index/aboutUs')
    },
    {
      path: '/product',
      name: 'Product',
      // component: () => import('../view/product/Product')
      component: () => import('../view/index/product')
    },
    {
      path: '/service',
      name: 'Service',
      // component: () => import('../view/service/Service')
      component: () => import('../view/index/service')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('../view/index/download')
    },
    {
      path: '/download_easternhanli',
      name: 'download_easternhanli',
      component: () => import('../view/index/download_easternhanli')
    },
    {
      path: '/download_laddercore',
      name: 'download_laddercore',
      component: () => import('../view/index/download_laddercore')
    },
    {
      path: '/download_languageworld',
      name: 'download_languageworld',
      component: () => import('../view/index/download_languageworld')
    },
    // {
    //   path: '/news',
    //   name: 'News',
    //   component: () => import('../view/news/News')
    // },
    {
      path: '/contactUs',
      name: 'ContactUs',
      // component: () => import('../view/contactUs/ContactUs')
      component: () => import('../view/footer')
    },
    {
      path: '/s10',
      name: 's10',
      component: () => import('../view/product/s10_detail')
    },
    {
      path: '/s10Pro',
      name: 's10Pro',
      component: () => import('../view/product/s10pro_detail')
    },
    {
      path: '/guidedLearning',
      name: 'guidedLearning',
      component: () => import('../view/index/guidedLearning')
    },
    {
      path: '/downloadAll',
      name: 'downloadAll',
      component: () => import('../view/index/downloadAll')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js